"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NAMING_LEVEL_LABELS = exports.BRAND_NAMING_CONVENTION_SCHEMA = exports.BRAND_NAMING_CONVENTION_VERSION = exports.NAMING_LEVEL_CONVENTION_SCHEMA = exports.NAMING_COMPONENT_SCHEMA = exports.NAMING_COMPONENT_VALUE_MAX_LENGTH = exports.NAMING_SPACES = exports.NAMING_CASES = exports.NAMING_DELIMITERS = exports.NAMING_LEVELS = void 0;
const zod_1 = require("zod");
/**
 * The brand-authored ad naming convention: how a brand names the campaigns, ad sets / ad groups and
 * ads the agent creates. Structured rather than prose, so the same definition drives the authoring
 * preview, the agent-facing prompt, and any future name composition — see
 * `naming-convention-format.ts` for the composition rule.
 */
/** The three ad-structure levels a convention covers. Matches `AD_NAMING_LEVELS` in the API. */
exports.NAMING_LEVELS = ['campaign', 'adSet', 'ad'];
/** Separator placed between a level's components. */
exports.NAMING_DELIMITERS = ['_', '|', '-', '.'];
/**
 * How a component's value is cased. `Aa` is deliberately a no-op ("as typed") rather than title
 * case — a value typed as `all Genders` stays `all Genders`.
 */
exports.NAMING_CASES = ['Aa', 'aa', 'AA'];
/** What happens to whitespace inside a component's value. */
exports.NAMING_SPACES = ['nospace', 'keep', 'with-dash'];
/** Longest value a single component may hold — a naming component is a token, not a sentence. */
exports.NAMING_COMPONENT_VALUE_MAX_LENGTH = 64;
/**
 * Component keys are free strings rather than a closed enum: a closed enum would make every future
 * catalog change a breaking read for brands that already saved. `normalizeBrandNamingConvention`
 * reconciles a stored payload against the current catalog instead.
 */
exports.NAMING_COMPONENT_SCHEMA = zod_1.z
    .object({
    key: zod_1.z.string().min(1).max(64),
    label: zod_1.z.string().min(1).max(128),
    value: zod_1.z.string().max(exports.NAMING_COMPONENT_VALUE_MAX_LENGTH),
    included: zod_1.z.boolean(),
})
    .strict();
exports.NAMING_LEVEL_CONVENTION_SCHEMA = zod_1.z
    .object({
    components: zod_1.z.array(exports.NAMING_COMPONENT_SCHEMA).max(32),
    delimiter: zod_1.z.enum(exports.NAMING_DELIMITERS),
    case: zod_1.z.enum(exports.NAMING_CASES),
    spaces: zod_1.z.enum(exports.NAMING_SPACES),
})
    .strict();
/** Bumped when the payload shape changes in a way `normalizeBrandNamingConvention` cannot absorb. */
exports.BRAND_NAMING_CONVENTION_VERSION = 1;
exports.BRAND_NAMING_CONVENTION_SCHEMA = zod_1.z
    .object({
    version: zod_1.z.literal(exports.BRAND_NAMING_CONVENTION_VERSION),
    campaign: exports.NAMING_LEVEL_CONVENTION_SCHEMA,
    adSet: exports.NAMING_LEVEL_CONVENTION_SCHEMA,
    ad: exports.NAMING_LEVEL_CONVENTION_SCHEMA,
})
    .strict();
/** Human label per level, used in prompts and in the UI's tab strip. */
exports.NAMING_LEVEL_LABELS = {
    campaign: 'Campaign',
    adSet: 'Ad set / Ad group',
    ad: 'Ad',
};
